// extracted by mini-css-extract-plugin
module.exports = {"culturePathSection":"cb_g8","cultureSectionHeader":"cb_g9","imageWrapper":"cb_K","cardWrapper":"cb_N","info":"cb_P"};